<template>
  <section>
    <container class="padding-top-4x">
      <h1 class="align-center">Volunteer Opportunity Application Form</h1>
      <volunteer-opportunities-submission-form></volunteer-opportunities-submission-form>
    </container>
  </section>
</template>

<script>
export default {
  name: 'Volunteer',
  metaInfo: {
    title: 'Volunteer Application | Festival Foods',
    meta: [
      {
        name: 'description',
        content: "Need volunteers? We'll help spread the word to associates and guests."
      },
      {
        property: 'og:title',
        content: 'Volunteer Application | Festival Foods'
      },
      {
        property: 'og:description',
        content: "Need volunteers? We'll help spread the word to associates and guests."
      },
      {
        property: 'og:image',
        content: 'https://storage.googleapis.com/assets.festfoods.com/images/about/community-involvement/volunteer-form-open-graph-image.jpg'
      }
    ]
  },
  components: {
    'volunteer-opportunities-submission-form': () => import('@/components/volunteer/OpportunitySubmissionForm')
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
</style>
